import { useMutation } from "@tanstack/react-query"
import type {
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query"

import client from "~/backend/axiosClient"

import type {
  ExportAllAgecStatsMutationResponse,
  ExportAllAgecStatsQueryParams,
} from "../types/ExportAllAgecStats"

type ExportAllAgecStatsClient = typeof client<
  ExportAllAgecStatsMutationResponse,
  Error,
  never
>
type ExportAllAgecStats = {
  data: ExportAllAgecStatsMutationResponse
  error: Error
  request: never
  pathParams: never
  queryParams: ExportAllAgecStatsQueryParams
  headerParams: never
  response: Awaited<ReturnType<ExportAllAgecStatsClient>>
  client: {
    parameters: Partial<Parameters<ExportAllAgecStatsClient>[0]>
    return: Awaited<ReturnType<ExportAllAgecStatsClient>>
  }
}
/**
 * @summary Export all AGEC stats
 * @link /v1/product/export-all-agec-stats
 */
export function useExportAllAgecStats(
  params: ExportAllAgecStats["queryParams"],
  options: {
    mutation?: UseMutationOptions<
      ExportAllAgecStats["response"],
      ExportAllAgecStats["error"],
      ExportAllAgecStats["request"]
    >
    client?: ExportAllAgecStats["client"]["parameters"]
  } = {}
): UseMutationResult<
  ExportAllAgecStats["response"],
  ExportAllAgecStats["error"],
  ExportAllAgecStats["request"]
> {
  const { mutation: mutationOptions, client: clientOptions = {} } =
    options ?? {}
  return useMutation<
    ExportAllAgecStats["response"],
    ExportAllAgecStats["error"],
    never
  >({
    mutationFn: async () => {
      const res = await client<
        ExportAllAgecStats["data"],
        ExportAllAgecStats["error"],
        ExportAllAgecStats["request"]
      >({
        method: "post",
        url: `/v1/product/export-all-agec-stats`,
        params,
        ...clientOptions,
      })
      return res
    },
    ...mutationOptions,
  })
}
